import types from "../../../actionTypes";

export const USER_PROFILE = types("USER_PROFILE");
